import { render, staticRenderFns } from "./agravosCepList.vue?vue&type=template&id=20ef79cc"
import script from "./agravosCepList.vue?vue&type=script&lang=js"
export * from "./agravosCepList.vue?vue&type=script&lang=js"
import style0 from "./agravosCepList.vue?vue&type=style&index=0&id=20ef79cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports